import { mdiContentPaste } from '@mdi/js';
import Command from './_Command';
import { ApryseSDK } from '../../pdf/ApryseSDK';

export default class SessionPasteController extends Command {
    constructor() {
        super({
            Key: 'sessionPasteAnnotation',
            Enabled: ApryseSDK.canSessionPaste,
            Path: mdiContentPaste,
            Callback: ApryseSDK.pasteSessionAnnotations,
        });
    }
}
